import { render } from "./AccessTokenWarning.vue?vue&type=template&id=f0ca0ad6&scoped=true"
import script from "./AccessTokenWarning.vue?vue&type=script&lang=js"
export * from "./AccessTokenWarning.vue?vue&type=script&lang=js"

import "./AccessTokenWarning.vue?vue&type=style&index=0&id=f0ca0ad6&scoped=true&lang=css"
import "./AccessTokenWarning.vue?vue&type=style&index=1&id=f0ca0ad6&lang=scss"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0ca0ad6"]])

export default __exports__